import React from "react";
import {
  VegaBox,
  VegaCard,
  VegaChip,
  VegaDivider,
  VegaFlex,
} from "@heartlandone/vega-react";
import ActivityState from "../ActivityInformations/State";
import ActivityTitle from "../ActivityInformations/Title";
import ActivityTimeRange from "../ActivityInformations/TimeRange";
import ActivityAddress from "../ActivityInformations/Address";
import ActivityCoverImage from "../ActivityInformations/CoverImage";
import ActivityKudo from "../ActivityInformations/Kudo";
import ActivityCategory from "../ActivityInformations/Category";
import ActivityChargeInline from "../ActivityInformations/ChargeInline";
import TeamRecruitment from "../ActivityInformations/TeamRecruitment";
import { ROUTES_PATH } from "Chore/Constants";
import { useNavigate, useLocation } from "react-router-dom";
import { isActivityFullyBooked } from "Chore/Utils";
import { ACTIVITY_STATUS } from "Chore/Constants";

const { STATUS_LABEL } = ACTIVITY_STATUS;

function FavoriteActivityListItem({ activity }) {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    address,
    activityStatus,
    isOnlineActivity,
    chargeAmount = 0,
    endTime,
    startTime,
    title,
    coverUrl,
    publisherCategory,
    city,
    hasFavorited,
    id,
    activityAllowRoles,
    isAllowInviteGuests,
  } = activity;

  const viewActivity = () => {
    navigate(`${ROUTES_PATH.ACTIVITY_INFO}/${id}`, {
      state: { from: location.pathname + location.search },
    });
  };

  return (
    <VegaCard
      padding="0"
      variant="border"
      style={{ cursor: "pointer" }}
      onClick={viewActivity}
    >
      <VegaBox style={{ position: "relative" }}>
        <ActivityCoverImage
          imageUrl={coverUrl || activity?.cover?.url}
          width="100%"
          borderRadius="11px 11px 0 0"
        />
        <VegaBox
          style={{
            position: "absolute",
            left: "16px",
            top: "16px",
          }}
        >
          <ActivityCategory category={publisherCategory} />
        </VegaBox>
        <VegaBox
          style={{
            position: "absolute",
            right: "16px",
            top: "16px",
          }}
        >
          <ActivityKudo activityId={id} hasFavorited={hasFavorited} />
        </VegaBox>
      </VegaBox>

      <VegaBox padding="size-16">
        <VegaFlex direction="col" gap={"size-16"}>
          <VegaFlex
            direction="col"
            gap="size-8"
            style={{ position: "relative" }}
          >
            <VegaFlex
              justifyContent="space-between"
              alignItems="start"
              style={{ height: "56px" }}
            >
              <ActivityTitle state={activityStatus} title={title} />
              <VegaBox flexShrink="0">
                <ActivityState state={activityStatus} />
              </VegaBox>
            </VegaFlex>
            <VegaFlex alignItems={"center"} gap={"size-16"}>
              <ActivityChargeInline
                activityStatus={activityStatus}
                chargeAmount={chargeAmount}
              />
              <TeamRecruitment roles={activityAllowRoles} />
            </VegaFlex>
          </VegaFlex>
          <VegaFlex direction="col">
            <VegaFlex gap="size-8">
              <VegaChip
                textColor={
                  activity.registerNumberLimitType === "Limited" &&
                  activity.registerNumberLimit === activity.participantsCount
                    ? "text-danger-link-visited"
                    : ""
                }
                text={`${activity.participantsCount}${
                  activity.registerNumberLimitType === "Limited"
                    ? `/${activity.registerNumberLimit}`
                    : ""
                }`}
                icon="fal fa-users"
                size="extra-small"
              ></VegaChip>
              {isAllowInviteGuests && (
                <VegaChip text="Guests Allowed" size="extra-small"></VegaChip>
              )}
              {!activity.hasRegistered &&
                activity.activityStatus !== STATUS_LABEL.CLOSED &&
                isActivityFullyBooked(activity) && (
                  <VegaChip
                    text="Fully Booked"
                    size="extra-small"
                    textColor="text-danger-link-visited"
                  ></VegaChip>
                )}
            </VegaFlex>
            <VegaDivider margin={{ y: "size-16" }} />
            <VegaFlex gap="size-16" direction="col">
              <ActivityTimeRange startTime={startTime} endTime={endTime} />
              <ActivityAddress
                online={isOnlineActivity}
                address={address}
                city={city}
              />
            </VegaFlex>
          </VegaFlex>
        </VegaFlex>
      </VegaBox>
    </VegaCard>
  );
}

export default FavoriteActivityListItem;
